<style>
@import url(@/assets/iconfont/iconfont.css);

html,body {
    margin: 0;
    height: 100%;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100%;
    color: #2b2b2b;

    --primary-color: #1677ff;
}

.colorText0 {
    background: linear-gradient(to right,
            #3ea9b7,
            #F1C72B,
            #0091ff,
            #3ea9b7);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: background-pan 3s linear infinite;
    background-size: 200%;
}
</style>

<template>
    <a-config-provider :locale="locale">
        <router-view />
    </a-config-provider>
</template>
<script>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');

export default {
    data() {
        return {
            locale: zhCN
        };
    }
};
</script>